module.exports = __webpack_public_path__ + "static/media/logo.30a2274b.png";